// extracted by mini-css-extract-plugin
export var altPlayIcon = "Video-module--altPlayIcon--db989";
export var autoPauseButton = "Video-module--autoPauseButton--94358";
export var autoPauseIcon = "Video-module--autoPauseIcon--d8457";
export var autoPlayIcon = "Video-module--autoPlayIcon--caa8b";
export var focusVisible = "Video-module--focus-visible--97768";
export var hasLoadingFrame = "Video-module--hasLoadingFrame--0acbc";
export var loadingFrame = "Video-module--loadingFrame--95b0d";
export var lowerPlayButton = "Video-module--lowerPlayButton--fc752";
export var mainVideo = "Video-module--mainVideo--b0fdb";
export var noBorderRadius = "Video-module--noBorderRadius--4c33c";
export var noFilter = "Video-module--noFilter--2b31c";
export var noPoster = "Video-module--noPoster--1d0e8";
export var orbitScale = "Video-module--orbitScale--4952e";
export var playIcon = "Video-module--playIcon--5011b";
export var poster = "Video-module--poster--12690";
export var posterPlayIcon = "Video-module--posterPlayIcon--70c5d";
export var small = "Video-module--small--7d827";
export var tint = "Video-module--tint--28b32";
export var video = "Video-module--video--30915";
export var videoContainer = "Video-module--videoContainer--e8e7c";
export var wrapper = "Video-module--wrapper--76ee2";